import { useSelector } from 'react-redux';
import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { getHasStarterFeatureAccess as getHasStarterFeatureAccessSelector, getIsJitaUser
// @ts-expect-error untyped import
} from 'MeetingsAdmin/selectors/AccessSelector';
// @ts-expect-error untyped import
import { getPortal } from 'MeetingsAdmin/selectors/AuthSelector';
import useObjectCount from 'MeetingsAdmin/hooks/useObjectCount';
import { FREE_TIER_CONTACTS_LIMIT } from 'MeetingsAdmin/constants/numbers';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export default function IndexUpgradeBanner() {
  const {
    count: contactsCount,
    loading: contactsCountLoading
  } = useObjectCount({
    objectTypeId: CONTACT_TYPE_ID
  });
  const portal = useSelector(getPortal);
  const contactsLimit = portal.limits['crm-contacts'] || FREE_TIER_CONTACTS_LIMIT;
  const hasStarterFeatureAccess = useSelector(getHasStarterFeatureAccessSelector);
  const isJitaUser = useSelector(getIsJitaUser);
  if (hasStarterFeatureAccess || isJitaUser || contactsCountLoading) {
    return null;
  }
  if (contactsCount >= contactsLimit) {
    return /*#__PURE__*/_jsx(UIUpgradeBanner, {
      "data-test-id": "freemium-meetings-upgrade-banner",
      marginStyle: {
        marginBlockEnd: '500'
      },
      upgradeKey: "import-export-crm-contacts-limit-banner",
      value: contactsCount,
      limit: contactsLimit
    });
  }
  return /*#__PURE__*/_jsx(UIUpgradeBanner, {
    "data-test-id": "freemium-meetings-upgrade-banner",
    marginStyle: {
      marginBlockEnd: '500'
    },
    upgradeKey: "meetings-remove-branding-index"
  });
}